import { Overview } from "@/modules/dashboard/screens/Overview";
import type { ModuleUi } from "@/modules/types";

/**
 * The Dashboard module.
 *
 * One section, and it is a fixed set of cards and charts rather than a
 * filtered list — `overview` declares no fields, the same way GST's
 * `hsn-summary` and `exports` do, and the toolbar's search, filter and
 * column controls sit out for the same reason.
 */
export const dashboardModule: ModuleUi = {
  id: "dashboard",
  sections: {
    overview: { fields: [], screen: Overview, padded: true },
  },
};
